import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('caixas' + params)
	},
}